import React, {Component} from 'react';
import PropTypes from 'prop-types';
import Wrapper from '../../components/wrapper';
import './styles.css';
import {getComponents} from "../utilities";
import BodyControl from "../../components/body";
import Slider from "../../components/slider";
import ModalWindow from "../../components/modal-window";
import Video from "../../blocks/video";
import MakerSetOptionMoreInfoItem from "../maker-set-option-more-info-item";

/**
 *  MakerSetOption
 */
class MakerSetOption extends Component {
  static propTypes = {
    containerId: PropTypes.string,
    containerClass: PropTypes.string,
    anchorPoint: PropTypes.string,
    anchorName: PropTypes.string,
    description: PropTypes.string,
    mbDescription: PropTypes.string,
    notice: PropTypes.string,
    makerSetOptionMoreInfoItems: PropTypes.arrayOf(PropTypes.node),
  };
  static defaultProps = {
    containerId: null,
    containerClass: null,
    anchorPoint: null,
    anchorName: null,
    description: null,
    mbDescription: null,
    notice: null,
    makerSetOptionMoreInfoItems: null,
  };
  
  constructor(props) {
    super();
    this.props = props;
    this.state = {};
    this.components = [];
    this.intervalId = null;
  }
  
  render() {

    this.components = [];
  
    // 詳細
    const renderDescription = () => {
      const getDescriptionPc = () => {
        if (this.props.description && this.props.description !== '') {
          return this.props.description;
        } else {
          return null;
        }
      };
      const getDescriptionMb = () => {
        if (this.props.mbDescription && this.props.mbDescription !== '') {
          return this.props.mbDescription;
        } else {
          return getDescriptionPc();
        }
      };
      const description = getDescriptionPc();
      const descriptionMb = getDescriptionMb();
      if (description && descriptionMb) {
        return (
          <div className="MakerSetOption__description Wysiwyg">
            <div className="MakerSetOption__description__content-pc"
                 dangerouslySetInnerHTML={{__html: description}}/>
            <div className="MakerSetOption__description__content-mb"
                 dangerouslySetInnerHTML={{__html: descriptionMb}}/>
          </div>
        )
      } else {
        return (
          null
        )
      }
    };
    
    // アイテム
    const renderItems = () => {
      if (this.props.makerSetOptionMoreInfoItems && 1 <= this.props.makerSetOptionMoreInfoItems.length) {
        return (
          <div className="MakerSetOption__items">
            {this.props.makerSetOptionMoreInfoItems.map((item, index) => {
              this.components.push('item' + index);
              return (
                <div className="MakerSetOption__items__item" key={index}>
                  <MakerSetOptionMoreInfoItem {...item.props} ref={'item' + index}
                    openModalWindow={(e) => {
                      e = Object.assign(e, {containerIndex: index});
                      this.openModal(e.containerIndex, e.itemIndex);
                    }}
                  />
                </div>
              )
            })}
          </div>
        )
      } else {
        return null;
      }
    };
    
    // 注釈
    const renderNotice = () => {
      if (this.props.notice && this.props.notice !== '') {
        return (
          <div className="MakerSetOption__notice Wysiwyg"
               dangerouslySetInnerHTML={{__html: this.props.notice}}/>
        )
      } else {
        return null;
      }
    };
    
    return (
      <Wrapper
        containerId={this.props.containerId}
        containerClass={this.props.containerClass}
        anchorPoint={this.props.anchorPoint}
        anchorName={this.props.anchorName}
      >
        <div className="MakerSetOption">
          <div className="MakerSetOption__container">
            {renderDescription()}
            {renderItems()}
            {renderNotice()}
          </div>
          <ModalWindow ref="modalWindow" type="Light" onClose={this.onCloseModal}>
            <ModalItems ref="modalItems" index={0} itemsProps={this.getModalItemInfo()} onChange={this.onChangeModal}/>
          </ModalWindow>
        </div>
      </Wrapper>
    )
  }
  
  componentDidMount() {
    window.addEventListener('resize', this.handleResize);
    if (this.intervalId) clearInterval(this.intervalId);
    this.intervalId = setInterval(()=> {
      this.handleResize();
    }, 500);
  };
  
  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
    if (this.intervalId) clearInterval(this.intervalId);
  }

  handleResize = () => {
    let maxHeight = 0;
    let i, max;
    for (i = 0, max = this.components.length; i < max; i = i + 1) {
      const component = this.refs[this.components[i]];
      if (component && component.getHeight) {
        const height = component.getHeight();
        if (maxHeight < height) {
          maxHeight = height;
        }
      }
    }
    //
    for (i = 0, max = this.components.length; i < max; i = i + 1) {
      const component = this.refs[this.components[i]];
      if (component && component.setHeight) {
        component.setHeight(maxHeight);
      }
    }
  };
  
  getModalItemInfo = () => {
    if (this.props.makerSetOptionMoreInfoItems) {
      let arr = [];
      let i, max;
      for (i = 0, max = this.props.makerSetOptionMoreInfoItems.length; i < max; i = i + 1) {
        const makerSetOptionMoreInfoItem = this.props.makerSetOptionMoreInfoItems[i].props;
        arr.push({
          index: i,
          detail: makerSetOptionMoreInfoItem.detail,
          mbDetail: makerSetOptionMoreInfoItem.mbDetail,
          makerSetOptionImageSrc: makerSetOptionMoreInfoItem.makerSetOptionImageSrc,
          mbMakerSetOptionImageSrc: makerSetOptionMoreInfoItem.mbMakerSetOptionImageSrc,
        })
      }
      return arr;
    } else {
      return [];
    }
  };
  
  openModal = (index) => {
    //this.refs.modalItems.slickGoTo(index, true);
    this.refs.modalItems.onChange(index);
    this.refs.modalWindow.open('Light', 'Light');
    // BODYのスクロール無効化
    //BodyControl.openModal();
  };
  
  onCloseModal = () => {
    //this.refs.modalItems.clearCurrentAll();
    // BODYのスクロール無効化を解除
    //BodyControl.closeModal();
  };
  
}

export default MakerSetOption;

class ModalItems extends Component {
  static propTypes = {
    itemsProps: PropTypes.array,
    index: PropTypes.number,
    onChange: PropTypes.func,
  };
  static defaultProps = {
    itemsProps: null,
    index: null,
    onChange: null,
  };
  
  constructor(props) {
    super(props);
    this.state = {
      currentIndex: 0,
    };
    this.modalItemArr = [];
  }
  
  // clearCurrentAll() {
  //   let i, max;
  //   for (i = 0, max = this.modalItemArr.length; i < max; i = i + 1) {
  //     const item = this.refs[this.modalItemArr[i]] || null;
  //     if (item) {
  //       item.clearCurrent();
  //     }
  //   }
  // }
  
  render() {
    const {
      itemsProps,
      index,
    } = this.props;
    //
    this.modalItemArr = [];
    //
    return (
      <div className="ModalItems">
        {itemsProps.map((itemProps, index) => {
          this.modalItemArr.push('modalItem' + index);
          if (this.state.currentIndex === index) {
            return (
              <ModalItem
                ref={'modalItem' + index}
                key={index}
                detail={(itemProps.detail) ? itemProps.detail: null}
                mbDetail={(itemProps.mbDetail) ? itemProps.mbDetail: null}
                //makerSetOptionImageSrc={(itemProps.makerSetOptionImageSrc) ? itemProps.makerSetOptionImageSrc: null}
                //mbMakerSetOptionImageSrc={(itemProps.mbMakerSetOptionImageSrc) ? itemProps.mbMakerSetOptionImageSrc: null}
                index={index}
              />
            )
          } else {
            return null;
          }
        })}
        {/*<ul className="ModalItems__list-dots">*/}
          {/*{itemsProps.map((itemProps, index) => {*/}
            {/*return (*/}
              {/*<li className={(index === this.state.currentIndex) ? ' current': ''} key={index}>*/}
                {/*<a className="ModalItems__link" href="javascript:void(0);" onClick={(e) => {*/}
                  {/*e.preventDefault();*/}
                  {/*if (this.refs.slider) this.refs.slider.slickGoTo(index);*/}
                {/*}}>{index + 1}</a>*/}
              {/*</li>*/}
            {/*)*/}
          {/*})}*/}
        {/*</ul>*/}
        {/*<Slider ref="slider"*/}
                {/*settings={{*/}
                  {/*autoplay: false,*/}
                  {/*speed: 1000,*/}
                  {/*ease: 'cubic-bezier(0.215, 0.61, 0.355, 1)',*/}
                  {/*fade: true,*/}
                  {/*infinite: true,*/}
                  {/*initialSlide: index,*/}
                  {/*slidesToShow: 1,*/}
                  {/*slidesToScroll: 1,*/}
                  {/*swipe: true,*/}
                  {/*draggable: false,*/}
                  {/*arrows: false,*/}
                  {/*dots: false,*/}
                  {/*adaptiveHeight: false,*/}
                  {/*//lazyLoad: 'progressive',*/}
                  {/*lazyLoad: 'ondemand',*/}
                  {/*waitForAnimate: false,*/}
                  {/*beforeChange: (old, current) => {*/}
                    {/*setTimeout(() => {*/}
                      {/*this.onChange(current);*/}
                    {/*}, 100);*/}
                    {/*this.refs.slider.beforeChange(old, current);*/}
                  {/*},*/}
                  {/*responsive: [*/}
                    {/*{*/}
                      {/*breakpoint: 767,*/}
                      {/*settings: {*/}
                        {/*arrows: false,*/}
                        {/*dots: false,*/}
                      {/*},*/}
                    {/*},*/}
                  {/*],*/}
                {/*}}*/}
        {/*>*/}
          {/*{itemsProps.map((itemProps, index) => {*/}
            {/*this.modalItemArr.push('modalItem' + index);*/}
            {/*return (*/}
              {/*<ModalItem*/}
                {/*ref={'modalItem' + index}*/}
                {/*key={index}*/}
                {/*detail={(itemProps.detail) ? itemProps.detail: null}*/}
                {/*mbDetail={(itemProps.mbDetail) ? itemProps.mbDetail: null}*/}
                {/*//makerSetOptionImageSrc={(itemProps.makerSetOptionImageSrc) ? itemProps.makerSetOptionImageSrc: null}*/}
                {/*//mbMakerSetOptionImageSrc={(itemProps.mbMakerSetOptionImageSrc) ? itemProps.mbMakerSetOptionImageSrc: null}*/}
                {/*index={index}*/}
              {/*/>*/}
            {/*)*/}
          {/*})}*/}
        {/*</Slider>*/}
      </div>
    );
  }
  
  //
  onChange = (index) => {
    // let i, max;
    // for (i = 0, max = this.modalItemArr.length; i < max; i = i + 1) {
    //   const item = this.refs[this.modalItemArr[i]] || null;
    //   if (item) {
    //     if (i === index) {
    //       item.setCurrent();
    //     } else {
    //       item.clearCurrent();
    //     }
    //   }
    // }
    //
    this.setState({
      currentIndex: index,
    });
    //
    if (this.props.onChange !== null) this.props.onChange(index);
  };
  
  //
  // slickGoTo = (index, dontAnimate) => {
  //   this.refs.slider.slickGoTo(index, dontAnimate);
  //   setTimeout(() => {
  //     this.onChange(index);
  //   }, 100);
  // }
  
}

class ModalItem extends Component {
  static propTypes = {
    detail: PropTypes.string,
    mbDetail: PropTypes.string,
    //makerSetOptionImageSrc: PropTypes.string,
    //mbMakerSetOptionImageSrc: PropTypes.string,
    index: PropTypes.number,
  };
  static defaultProps = {
    detail: null,
    mbDetail: null,
    //makerSetOptionImageSrc: null,
    //mbMakerSetOptionImageSrc: null,
    index: null,
  };
  
  constructor(props) {
    super(props);
    this.state = {
      //current: false,
      windowHeight: null,
    };
  }
  
  componentDidMount() {
    window.addEventListener('resize', this.handleResize);
    this.handleResize();
  };
  
  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
  }
  
  //
  // setCurrent() {
  //   if (this.state.current === true) return;
  //   //
  //   this.setState({
  //     current: true,
  //   });
  // };
  //
  // //
  // clearCurrent() {
  //   if (this.state.current === false) return;
  //   //
  //   this.setState({
  //     current: false,
  //   });
  // }
  
  render() {
    let {
      detail,
      mbDetail,
      //makerSetOptionImageSrc,
      //mbMakerSetOptionImageSrc,
    } = this.props;
    
    const getDetailPc = () => {
      if (detail && detail !== '') {
        return detail;
      } else {
        return null;
      }
    };
    const getDetailMb = () => {
      if (mbDetail && mbDetail !== '') {
        return mbDetail;
      } else {
        return getDetailPc();
      }
    };
    
    //
    // const getMakerSetOptionImageSrc = ()=> {
    //   if (makerSetOptionImageSrc && makerSetOptionImageSrc !== '') {
    //     return makerSetOptionImageSrc;
    //   } else {
    //     return null;
    //   }
    // };
    
    //
    // const getMbMakerSetOptionImageSrc = ()=> {
    //   if (mbMakerSetOptionImageSrc && mbMakerSetOptionImageSrc !== '') {
    //     return mbMakerSetOptionImageSrc;
    //   } else {
    //     return getMakerSetOptionImageSrc();
    //   }
    // };
  
    detail = getDetailPc();
    mbDetail = getDetailMb();
  
    //
    return (
      <div className="MakerSetOption__modal-item"
           style={(0 < this.state.windowHeight) ? {height: this.state.windowHeight}: null}>
        <div className="MakerSetOption__modal-item__box"
             style={(0 < this.state.windowHeight) ? {height: this.state.windowHeight}: null}>
          <div className="MakerSetOption__modal-item__box-full">
            <p className="MakerSetOption__modal-item__detail Wysiwyg">
              <span className="MakerSetOption__modal-item__detail-pc" dangerouslySetInnerHTML={{__html: detail}}/>
              <span className="MakerSetOption__modal-item__detail-mb" dangerouslySetInnerHTML={{__html: mbDetail}}/>
            </p>
          </div>
        </div>
      </div>
    );
    // return (
    //   <div className="MakerSetOption__modal-item"
    //        style={(0 < this.state.windowHeight) ? {height: this.state.windowHeight}: null}>
    //     {(() => {
    //       if (makerSetOptionImageSrc && makerSetOptionImageSrc !== '') {
    //         return (
    //           <div className="MakerSetOption__modal-item__box"
    //                style={(0 < this.state.windowHeight) ? {height: this.state.windowHeight}: null}>
    //             <div className="MakerSetOption__modal-item__box-left">
    //               <div className="MakerSetOption__modal-item__image" >
    //                 <img className="MakerSetOption__modal-item__image-pc" src={getMakerSetOptionImageSrc()} alt=""/>
    //                 <img className="MakerSetOption__modal-item__image-mb" src={getMbMakerSetOptionImageSrc()} alt=""/>
    //               </div>
    //             </div>
    //             <div className="MakerSetOption__modal-item__box-right">
    //               <p className="MakerSetOption__modal-item__detail Wysiwyg">
    //                 {(detail && detail !== '') ?
    //                   <span className="MakerSetOption__modal-item__detail-pc" dangerouslySetInnerHTML={{__html: detail}}/>
    //                   : null}
    //                 {(mbDetail && mbDetail !== '') ?
    //                   <span className="MakerSetOption__modal-item__detail-mb" dangerouslySetInnerHTML={{__html: mbDetail}}/>
    //                   : null}
    //               </p>
    //             </div>
    //           </div>
    //         )
    //       } else {
    //         return (
    //           <div className="MakerSetOption__modal-item__box"
    //                style={(0 < this.state.windowHeight) ? {height: this.state.windowHeight}: null}>
    //             <div className="MakerSetOption__modal-item__box-full">
    //               <p className="MakerSetOption__modal-item__detail Wysiwyg">
    //                 <span className="MakerSetOption__modal-item__detail-pc" dangerouslySetInnerHTML={{__html: detail}}/>
    //                 <span className="MakerSetOption__modal-item__detail-mb" dangerouslySetInnerHTML={{__html: mbDetail}}/>
    //               </p>
    //             </div>
    //           </div>
    //         )
    //       }
    //     })()}
    //   </div>
    // );
  }
  
  //
  handleResize = () => {
    const windowHeight = window.innerHeight;
    //
    this.setState({
      windowHeight: windowHeight,
    });
  };
  
}



// WEBPACK FOOTER //
// ./src/containers/maker-set-option/index.jsx